export default "__VITE_ASSET__DMEX7cog__"